import { render } from "./LimitsModal.vue?vue&type=template&id=1a889ea9&scoped=true"
import script from "./LimitsModal.vue?vue&type=script&lang=js"
export * from "./LimitsModal.vue?vue&type=script&lang=js"

import "./LimitsModal.vue?vue&type=style&index=0&id=1a889ea9&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a889ea9"]])

export default __exports__